import { Component, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { take } from 'rxjs/operators';
import {
    endOfMonth,
    endOfWeek,
    endOfYear,
    startOfMonth,
    startOfWeek,
    startOfYear,
    subDays,
    subMonths,
    subYears,
} from 'date-fns';
import { SessionUser } from 'src/app/model/session.user';
import { CommonService } from 'src/app/services/common.service';
import { CompanyService } from 'src/app/services/company.service';
import { LoginService } from 'src/app/services/login.service';
import { CashbackGraphComponent } from '../cashback-graph/cashback-graph.component';
import { SalesGraphComponent } from '../sales-graph/sales-graph.component';
@Component({
    selector: 'app-sales-dashboard',
    templateUrl: './sales-dashboard.component.html',
    styleUrls: ['./sales-dashboard.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class SalesDashboardComponent implements OnInit {
    @ViewChild(SalesGraphComponent) salesGraphComponent!: SalesGraphComponent;
    @ViewChild(CashbackGraphComponent) cashbackGraphComponent!: CashbackGraphComponent;
    private previousWidth: number = window.innerWidth;
    private previousHeight: number = window.innerHeight;
    presetRanges: any = {};
    headerText1: string = 'Sales';
    headerText2: string = 'Cashback';
    activeTab: 'sales' | 'cashback' = 'sales';
    user: SessionUser;
    dashboardParameters: any = null;
    public showAccountTab: boolean = false;

    constructor(
        public companyService: CompanyService,
        private commonService: CommonService,
        public loginService: LoginService,
    ) {}

    ngOnInit(): void {
        this.loginService.sessionUser.pipe(take(1)).subscribe((user) => {
            this.user = user;
            this.showAccountTab = !user?.isEnterprise?.();
        });

        const today = new Date();
        const yesterday = subDays(today, 1);
        const startWeek = startOfWeek(today, { weekStartsOn: 1 });
        const endWeek = endOfWeek(today, { weekStartsOn: 1 });

        this.presetRanges = {
            todayStart: today,
            todayEnd: today,
            yesterdayStart: yesterday,
            yesterdayEnd: yesterday,
            weekStart: startWeek,
            weekEnd: endWeek,
            lastWeekStart: subDays(startWeek, 7),
            lastWeekEnd: subDays(endWeek, 7),
            monthStart: startOfMonth(today),
            monthEnd: endOfMonth(today),
            lastMonthStart: startOfMonth(subMonths(today, 1)),
            lastMonthEnd: endOfMonth(subMonths(today, 1)),
            yearStart: startOfYear(today),
            yearEnd: endOfYear(today),
            lastYearStart: startOfYear(subYears(today, 1)),
            lastYearEnd: endOfYear(subYears(today, 1)),
        };
    }

    setActiveTab(tab: 'sales' | 'cashback'): void {
        this.activeTab = tab;
    }

    onTabSelected(args: any): void {
        const selectedIndex = args.selectedIndex;
        if (selectedIndex === 0) {
            this.activeTab = 'sales';
        } else if (selectedIndex === 1) {
            this.activeTab = 'cashback';
        }

        setTimeout(() => {
            this.onWindowResize();
        }, 100);
    }

    @HostListener('window:resize', ['$event'])
    onWindowResize(event?: UIEvent): void {
        const currentWidth = window.innerWidth;
        const currentHeight = window.innerHeight;
        if (currentWidth !== this.previousWidth || currentHeight !== this.previousHeight) {
            this.previousWidth = currentWidth;
            this.previousHeight = currentHeight;
            location.reload();
        } else {
            requestAnimationFrame(() => {
                if (this.activeTab === 'sales') {
                    this.salesGraphComponent?.refreshCharts();
                } else if (this.activeTab === 'cashback') {
                    this.cashbackGraphComponent?.refreshCharts();
                }
            });
        }
    }
}
